module.exports = __webpack_public_path__ + "static/media/xray-training-lateral-flex1.fa154b02.png";